import { makeStyles } from "@material-ui/styles";

export default makeStyles({
  container: {
    padding: "15px 0px 15px 0px",
    backgroundColor: 'white',
    zIndex: 0
  },
  
  logo: {
    height: 40
  },

  logoChiquito: {
    height: 30
  },

  codPresta: {
    display: "flex",
    alignItems: "center",
    marginRight: 30,
  },

  containerDatos: {
    display: "flex",
    justifyContent: "flex-end",
  },
});
